import { dashboardService } from '@/service/console/dashboard.service';
import type { ApiSingleResponse } from '@/types/api.config';
import type { BasicInfoContent, DashboardContent } from '@/types/dashboard';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from './query-key';

export function useDashboardQuery(params?: {
  days?: number;
  newsLimit?: number;
  faqLimit?: number;
}) {
  return useQuery<ApiSingleResponse<DashboardContent>>({
    queryKey: queryKeys.dashboard(
      params?.days,
      params?.newsLimit,
      params?.faqLimit
    ),
    queryFn: () => dashboardService.getDashboard(params),
    staleTime: 1000 * 60 * 5,
  });
}

export function useBasicInfoQuery() {
  return useQuery<ApiSingleResponse<BasicInfoContent>>({
    queryKey: queryKeys.basicInfo,
    queryFn: () => dashboardService.getBasicInfo(),
    staleTime: 1000 * 60 * 5,
  });
}
